export default "__VITE_ASSET__CvMPLjPl__"